import { render, staticRenderFns } from "./StrPlanDetay.vue?vue&type=template&id=6fb05c62"
import script from "./StrPlanDetay.vue?vue&type=script&lang=js"
export * from "./StrPlanDetay.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports